import Styled from 'styled-components';

const Option = Styled.div`
  position: relative;
  line-height: 20px;
  cursor: pointer;
  display: flex;

  > input {
    appearance: none;
    width: 0;
    height: 0;
  }

  > label {
    width: 100%;
    height: 100%;
    cursor: pointer;

    &:hover {
      color: #000;
    }
  }

`;

const Select = Styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.fontSize.xs};
  gap:6px;
`;

export default Select;
export { Select, Option };
